import { render } from "./RefundOrderCard.vue?vue&type=template&id=3756d68c&scoped=true"
import script from "./RefundOrderCard.vue?vue&type=script&lang=js"
export * from "./RefundOrderCard.vue?vue&type=script&lang=js"

import "./RefundOrderCard.vue?vue&type=style&index=0&id=3756d68c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3756d68c"]])

export default __exports__